import { useState } from 'react'
import { JACKPOT_TAB, JACKPOT_VIEW_TYPE } from '@constants/jackpotConstants'
import { useJackpotNavigation } from '@hooks/jackpot/useJackpotNavigation'
import ActiveJackpotTab from './ActiveJackpotTab'
import JackpotHistoryTab from './JackpotHistoryTab'

const TABS = Object.values(JACKPOT_TAB)

// Root of the JACKPOT screen: a 2-tab segmented control (Active/History),
// same shape as TournamentsMenu. `initialTab` is read back from the sidebar
// stack entry's params so the tab survives a drill-down + back.
const JackpotMenu = ({ initialTab }) => {
  const { onSelectJackpotTab } = useJackpotNavigation()
  const [currentTab, setCurrentTab] = useState(initialTab ?? TABS[0].KEY)
  const [slideDirection, setSlideDirection] = useState(1)

  const activeIndex = TABS.findIndex((tab) => tab.KEY === currentTab)
  const activeTab = JACKPOT_TAB[currentTab] ?? TABS[0]

  const handleTabChange = (nextKey) => {
    if (nextKey === currentTab) return
    const nextIndex = TABS.findIndex((tab) => tab.KEY === nextKey)
    setSlideDirection(nextIndex >= activeIndex ? 1 : -1)
    setCurrentTab(nextKey)
    onSelectJackpotTab(nextKey)
  }

  return (
    <div className="standard-normal-jackpot-menu-outer-container">
      <div
        className="standard-normal-jackpot-menu-tabs-container"
        style={{
          '--jackpot-tab-count': TABS.length,
          '--jackpot-tab-index': activeIndex,
        }}
      >
        {TABS.map((tab) => (
          <div
            key={tab.KEY}
            className={`standard-normal-jackpot-menu-tab ${tab.KEY === currentTab ? 'standard-normal-jackpot-menu-active-tab' : ''}`}
            onClick={() => handleTabChange(tab.KEY)}
          >
            {tab.LABEL}
          </div>
        ))}
        <span className="standard-normal-jackpot-menu-tab-indicator" aria-hidden="true" />
      </div>

      <div className="standard-normal-jackpot-menu-content-container">
        <div
          key={currentTab}
          className="standard-normal-jackpot-menu-content"
          style={{ '--jackpot-slide-direction': slideDirection }}
        >
          {activeTab.VIEW_TYPE === JACKPOT_VIEW_TYPE.ACTIVE ? <ActiveJackpotTab /> : <JackpotHistoryTab />}
        </div>
      </div>
    </div>
  )
}

export default JackpotMenu
